/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {},
  rules: [],
  tokens: {
    rangeBackground: 'rgba(0, 0, 0, 0)',
    remainingTimestampMarginLeft: 8,
    remainingTimestampMarginRight: 0,
    thumbBackground: '#ffffff',
    thumbHeight: 8,
    thumbWidth: 8,
    timestampMarginLeft: 0,
    timestampMarginRight: 8,
    trackGradientEnd: '#66cc00',
    trackGradientStart: '#66cc00'
  }
}
export default theme
